import '../styles/RecentActivityPanel.css'

export default function RecentActivityPanel({ rows }) {
  return (
    <aside className="recent-activity-panel pr-widget" aria-label="Activité récente">
      <h3>Activité des dernières 48 h</h3>
      {rows.length === 0 ? <p>Aucune activité publique géolocalisée.</p> : (
        <ul>{rows.slice(0, 8).map((row) => (
          <li key={row.id}>
            <span className={`activity-dot activity-dot--${row.category}`} aria-hidden="true" />
            <div><strong>{row.title}</strong><span>{row.country_name || row.region_name || 'Monde'}</span>
              <time dateTime={row.occurred_at}>{row.occurred_at}</time></div>
          </li>
        ))}</ul>
      )}
    </aside>
  )
}
